/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { fetchInternalOrderById } from '@/api/orders';
import { InternalOrderOverviewTab } from '@/app/(client)/orders/-components/InternalOrderOverviewTab';
import {
  internalOrderDetailKeys,
  useInternalOrderDetail,
} from '@/app/(client)/orders/-hooks/useInternalOrderDetail';
import { useOrderTags } from '@/app/(client)/orders/-hooks/useOrderTags';
import { useOrderTypes } from '@/app/(client)/orders/-hooks/useOrderTypes';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: internalOrderDetailKeys.detail(params.ioId),
      queryFn: () => fetchInternalOrderById(params.ioId).then(res => res.data),
    }),
  component: InternalOrderOverviewRoute,
  pendingComponent: () => null,
});

function InternalOrderOverviewRoute() {
  const { ioId } = Route.useParams();
  const { data: order } = useInternalOrderDetail(ioId);
  const { data: orderTags } = useOrderTags();
  const { data: orderTypes } = useOrderTypes();

  if (!order) return null;

  return (
    <InternalOrderOverviewTab
      order={order}
      orderTags={orderTags ?? []}
      orderTypes={orderTypes ?? []}
    />
  );
}
